<script>
  import { LmsUtils } from '../../../../../LMS/utils/LmsUtils';
  import { External, M } from '../../../../../external';

  export let activityType, data = {
    circleId: '', circleName: '', groupId: '', groupName: '', pageId: '', pageName: '',
    groupCompleted: false, circleCompleted: false
  }, contact;

  let clickHandler = async () => {
    let circles = await LmsUtils.listCircles();
    let circle = circles.find(circle => circle.id === data.circleId);
    if (circle) {
      External.CPanel.goToUrl(`/me/community/circles/${circle.url}`);
    }
  };

</script>
<a class="blue-text" on:click={clickHandler}>
  {#if data.groupName}
    {M.PAGE}: {data.circleName} → {data.groupName} → {data.pageName}
  {:else}
    {M.PAGE}: {data.circleName} → {data.pageName}
  {/if}
  {#if data.groupCompleted}
    <br />{M.CIRCLE_GROUP}: {data.circleName} → {data.groupName}
  {/if}
  {#if data.circleCompleted}
    <br />{M.CIRCLE}: {data.circleName}
  {/if}
</a>
